import PageSpeedAnalyzer from '../components/PageSpeedAnalyzer';
import PageSeo from '../components/SEO/PageSeo';

const PageSpeed = () => {
  return (
    <>
      <PageSeo 
        title="Website Performance Analysis Tool" 
        description="Analyze your website's speed, performance, and SEO with our comprehensive PageSpeed analysis tool. Get detailed reports and actionable recommendations." 
        keywords={[
          'website speed test', 
          'performance analysis', 
          'lighthouse score', 
          'PageSpeed insights', 
          'website optimization', 
          'SEO analysis',
          'web performance'
        ]}
        ogType="website"
      />
      <div className="container mx-auto px-4 py-8 analysis-page">
        <h1 className="text-3xl font-bold mb-6">Website Performance & Technology Analysis</h1>
        <div className="bg-white rounded-lg shadow-md p-6">
          <PageSpeedAnalyzer />
        </div>
      </div>
    </>
  );
};

export default PageSpeed;